<template>
  <div class="table">
    <div class="headDiv">
      <a-select class="select" v-if="userInfo().role == 'ROLE_SYSTEM'" v-model="searchData.bussdepid">
        <a-select-option value="">--请选择事业部--</a-select-option>
        <a-select-option v-for="item in businssDept" :value="item.id" :key="item.id">{{ item.name }}</a-select-option>
      </a-select>
      &nbsp;&nbsp;
      <a-select class="select" v-model="searchData.bussdepType">
        <a-select-option value="">--请选择业务--</a-select-option>
        <a-select-option :value="item.key" v-for="item in bussdepType" :key="item.key">{{ item.value }}</a-select-option>
      </a-select>
      &nbsp;&nbsp;
      <a-select class="select" v-model="searchData.bussdepName" v-if="searchData.bussdepType">
        <a-select-option value="">--内容来源--</a-select-option>
        <a-select-option v-for="item in filterChildList" :value="item.name" :key="item.id">{{ item.name }}</a-select-option>
      </a-select>
      &nbsp;&nbsp;
      <a-select class="select" v-model="searchData.state">
        <a-select-option value="">--状态--</a-select-option>
        <a-select-option value="1">正常</a-select-option>
        <a-select-option value="2">已移除</a-select-option>
      </a-select>
      &nbsp;&nbsp;
      <a-input placeholder="UID" v-model="searchData.uid"></a-input>
      &nbsp;&nbsp;
      <a-input placeholder="昵称" v-model="searchData.nickName"></a-input>
      &nbsp;&nbsp;
      <a-button type="primary" @click="search">搜索</a-button>
      &nbsp;
      <a-button type="default" @click="reset">重置</a-button>
    </div>
    <a-table rowKey="id" :loading="loading" :dataSource="userList" :pagination="pagination" @change="handleTableChange">
      <a-table-column title="id" dataIndex="id" />
      <a-table-column title="用户uid" dataIndex="uid" />
      <a-table-column title="用户昵称" dataIndex="nickName" />
      <a-table-column title="内容名称" dataIndex="auditapp.name" />
      <a-table-column
        title="业务来源"
        dataIndex="auditapp.bussdepType"
      ><template slot-scope="scope">
        {{ filterBussdepType(scope) }}
      </template>
      </a-table-column>
      <a-table-column title="添加时间" dataIndex="createTime" />
      <a-table-column title="操作人" dataIndex="userName">
        <span slot-scope="userName">{{ bzNamefilter(userName) }} </span>
      </a-table-column>
      <a-table-column
        title="状态"
        dataIndex="state"
      ><template slot-scope="state">
        {{ state == 1 ? '正常' : '移除' }}
      </template>
      </a-table-column>
      <a-table-column title="备注" dataIndex="remarks" />
      <a-table-column
        title="操作"
      ><template slot-scope="userid">
        <a-popconfirm
          v-show="userid.state == 1"
          title="移除黑名单后，该用户发言将不被禁止？"
          @confirm="deleteAccout(userid.id)"
        >
          <a>移除</a> </a-popconfirm
          >&nbsp;
        <a @click="checkHistory(userid.id)">查看历史</a>
      </template>
      </a-table-column>
    </a-table>
    <a-modal
      title="历史记录"
      width="600px"
      @ok="handleOk"
      :footer="null"
      @cancel="visible = false"
      :visible="visible">
      <a-table rowKey="id" :loading="loading" :dataSource="userList1" :pagination="false">
        <a-table-column title="时间" dataIndex="createTime" />
        <a-table-column title="操作人" dataIndex="userName">
          <span slot-scope="userName">{{ bzNamefilter(userName) }} </span>
        </a-table-column>
        <a-table-column
          title="操作"
        ><template slot-scope="item">
          {{ item.userName + (item.operation == 1 ? '添加黑名单' : '移除黑名单') }}
        </template>
        </a-table-column>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { bussdepType, filterBussdepType } from '@/config/public'
import { nameFilter } from '@/utils/BzFilter.js'
import { listhistory, removeItem, queryList } from '@/api/blackList'
import { depList, configmanageList } from '@/api/common'
var searchData = {
  bussdepType: '',
  bussdepName: '',
  state: '',
  uid: '',
  bussdepid: '',
  nickName: '',
}
export default {
  name: 'BlackList',
  components: {},
  data() {
    return {
      searchData: JSON.parse(JSON.stringify(searchData)),
      pagination: {
        pageSize: 20,
        total: 0,
        showTotal: (total) => `总共 ${total} 条`,
        current: 1,
      },
      bussdepType: bussdepType,
      filterBussdepType: filterBussdepType,
      loading: false,
      visible: false,
      userList: [],
      userList1: [],
      childList: [],
      businssDept: [],
      filterChildList: [],
    }
  },
  created() {},
  mounted() {
    if (window.environment == 'bz') {
      this.bussdepType = bussdepType.filter((item) => item.value === '投教')
    }
    this.getList()
    this.getAllChildList()
    if (this.userInfo().role == 'ROLE_SYSTEM') {
      depList().then((res) => {
        if (res.code == 1) {
          if (window.environment == 'bz') {
            this.businssDept = res.result.filter((item) => item.name == '博众事业部')
          } else {
            this.businssDept = res.result
          }
        }
      })
    }
  },
  methods: {
    ...mapGetters(['userInfo']),
    bzNamefilter(name) {
      return nameFilter(name)
    },
    getAllChildList() {
      configmanageList().then((res) => {
        if (res.code == 1) {
          if (res.result && res.result instanceof Array) {
            this.childList = res.result
          }
        }
      })
    },
    checkHistory(id) {
      this.visible = true
      listhistory({ blacklistId: id }).then((res) => {
        if (res.code == 1 && res.result) {
          this.userList1 = res.result
        }
      })
    },
    reset() {
      this.searchData = JSON.parse(JSON.stringify(searchData))
    },
    deleteAccout(id) {
      removeItem({ blackListId: id }).then((res) => {
        if (res.code == 1) {
          this.$message.success('操作成功')
          this.getList()
        }
      })
    },
    getList() {
      var params = JSON.parse(JSON.stringify(this.searchData))
      params.page = this.pagination.current - 1
      params.size = this.pagination.pageSize
      this.loading = true
      queryList(params)
        .then((res) => {
          if (res.code == 1 && res.result && res.result.content) {
            this.userList = res.result.content
            this.pagination.total = res.result.totalElements
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleOk() {},
    search() {
      this.getList(this.searchData)
    },
    handleTableChange(pagination) {
      const pager = { ...this.pagination }
      pager.current = pagination.current
      this.pagination = pager
      this.getList()
    },
  },
  watch: {
    'searchData.bussdepType': function (val) {
      this.filterChildList = this.childList.filter((item) => item.bussdepType == val)
    },
  },
}
</script>

<style lang="less" scoped>
.headDiv {
  padding: 20px;
  /*margin: 10px;*/
  input {
    width: 200px;
  }
}
.select {
  width: 200px;
}
.ant-form-item {
  margin-bottom: 0;
}
</style>